import { render, staticRenderFns } from "./HomeBot.vue?vue&type=template&id=7b195616&scoped=true&"
import script from "./HomeBot.vue?vue&type=script&lang=js&"
export * from "./HomeBot.vue?vue&type=script&lang=js&"
import style0 from "./HomeBot.vue?vue&type=style&index=0&id=7b195616&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b195616",
  null
  
)

export default component.exports